module.exports = __webpack_public_path__ + "static/media/user.c98599a1.svg";